import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Layout from "./components/layout";
import ProtectedRoute from "./components/ProtectedRoute";

import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";

import POPage from "./pages/POPage";
import POListPage from "./pages/POListPage";
import PODetailsPage from "./pages/PODetailsPage";

import VendorsPage from "./pages/VendorsPage";
import SitesPage from "./pages/SitesPage";

import POPrintPage from "./pages/POPrintPage";

import SiteSummaryPage from "./pages/SiteSummaryPage";
import SitePurchasePage from "./pages/SitePurchasePage";

import PriceListPage from "./pages/PriceListPage";

import RFQPage from "./pages/RFQPage";
import VendorRFQPage from "./pages/VendorRFQPage";
import RFQListPage from "./pages/RFQListPage";

import ComparisonListPage from "./pages/ComparisonListPage";
import ComparisonDetailsPage from "./pages/ComparisonDetailsPage";

import MaterialMaster from "./pages/MaterialMaster";

import SiteViewPage from "./pages/SiteViewPage";

import UserManagement from "./pages/UserManagement";

import { useParams } from "react-router-dom";
import RFQDetailsPage from "./pages/RFQDetailsPage";
import { BOQWorkspaceLandingPage, BOQProjectWorkspaceCompactPage } from "./pages/BOQWorkspacePage";
import BOQDesignItemsPage from "./pages/BOQDesignItemsPage";
import BOQBreakupPage from "./pages/BOQBreakupPage";




/* PRINT WRAPPER */

function POPrintPageWrapper() {

  const { id } = useParams();

  return <POPrintPage poId={id} />;
}



/* ADMIN ROUTE */

function AdminRoute({ children }) {

  const user = JSON.parse(
    localStorage.getItem("user")
  );

  if (!user || user.role !== "admin") {

    return <Navigate to="/dashboard" />;
  }

  return children;
}



function App() {

  return (

    <BrowserRouter>

      <Routes>

        {/* LOGIN PAGE */}

  <Route
    path="/"
    element={<LoginPage />}
  />


  {/* PUBLIC VENDOR RFQ */}

  <Route
    path="/vendor-rfq/:rfqId/:vendorId"
    element={<VendorRFQPage />}
  />

  {/* PROTECTED LAYOUT */}

  <Route
    element={
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    }
  >

          {/* DASHBOARD */}

          <Route
            path="dashboard"
            element={<DashboardPage />}
          />



          {/* PURCHASE */}

          <Route
            path="purchase-order"
            element={<POPage />}
          />

          <Route
            path="po-list"
            element={<POListPage />}
          />

          <Route
            path="po/:id"
            element={<PODetailsPage />}
          />
            <Route path="/boq-workspace" element={<BOQWorkspaceLandingPage />} />
            <Route path="/boq-workspace/:projectId" element={<BOQProjectWorkspaceCompactPage />} />
            <Route path="/boq-workspace/:projectId/section/:sectionId" element={<BOQDesignItemsPage />} />
            <Route path="/boq-breakup/:itemId" element={<BOQBreakupPage />} />



          {/* VENDORS */}

          <Route
            path="vendors"
            element={<VendorsPage />}
          />



          {/* SITES */}

          <Route
            path="sites"
            element={<SitesPage />}
          />



          {/* SITE SUMMARY */}

          <Route
            path="site-summary"
            element={<SiteSummaryPage />}
          />



          {/* PRINT */}

          <Route
            path="print/:id"
            element={<POPrintPageWrapper />}
          />



          {/* SITE PURCHASE */}

          <Route
            path="site-purchase"
            element={<SitePurchasePage />}
          />



          {/* PRICE LIST */}

          <Route
            path="price-list"
            element={<PriceListPage />}
          />



          {/* RFQ */}

          <Route
            path="rfq"
            element={<RFQPage />}
          />

          <Route
            path="create-rfq"
            element={<RFQPage />}
          />

          <Route
            path="vendor-rfq/:rfqId/:vendorId"
            element={<VendorRFQPage />}
          />

          <Route
            path="rfq-list"
            element={<RFQListPage />}
          />

           <Route
  path="rfq-details/:id"
  element={<RFQDetailsPage />}
/>


          {/* COMPARISON */}

          <Route
            path="comparison"
            element={<ComparisonListPage />}
          />

          <Route
            path="comparison/:id"
            element={<ComparisonDetailsPage />}
          />



          {/* MATERIAL MASTER */}

          <Route
            path="material-master"
            element={<MaterialMaster />}
          />



          {/* SITE VIEW */}

          <Route
            path="site-view/:id"
            element={<SiteViewPage />}
          />

          <Route
  path="user-management"
  element={
    <AdminRoute>
      <UserManagement />
    </AdminRoute>
  }
/>
          
        </Route>

      </Routes>

    </BrowserRouter>

  );
}

export default App;
